@if (!cookieStatus) {
  <div class="cookie_banner">
    <div class="line_wrapper">
      <div class="cookie_banner_text" [innerHTML]="'COOKIE_BANNER.TEXT_LINE_1' | translate"></div>
      <div class="cookie_banner_text" [innerHTML]="'COOKIE_BANNER.TEXT_LINE_2' | translate"></div>
    </div>
    <div class="line_wrapper">
      <button (click)="setCookie()" [innerHTML]="'COOKIE_BANNER.ACCEPT' | translate"></button>
    </div>
  </div>
}
